<template>
  <div class="product" :class="{TA:isTestAchat}">
    <span class="bestprice" v-if="range.range === featured">{{
        ! isTestAchat ? $t('Offer.Product.advise') : $t('branding.TA.offer')
      }}</span>
    <h1>
      <SvgIcon class="icon" :icon="`product-${productName}`" fill></SvgIcon>
      {{ productName | capitalize }}
    </h1>
    <template v-if="!isYearly">
      <div class="price" v-if="price" v-bind:class="{ noSpace: priceWithoutPromoByFrequency }">
        <div class="inline center">
          <span class="barred small right-margin"
                v-if="priceWithoutPromoByFrequency">{{ priceWithoutPromoByFrequency | formatPrice }}</span> <span
            class="bold">{{ priceByFrequency | formatPrice }}</span>
          <span class="unit">€ {{ priceLabel }} /{{
              $tc(`Offer.Product.${paymentFrequency}`)
            }}</span>
        </div>
        <div class="annual inline center">
          <span class="barred right-margin" v-if="priceWithoutPromo.annual">{{
              priceWithoutPromo.annual | formatPrice
            }}</span> <span> {{ price.annual | formatPrice }}</span>
          <span class="unit">€ {{ priceLabel }} /{{ $tc('Offer.Product.year') }}{{showDisclaimer ? "**" : ""}}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="price" v-if="price" v-bind:class="{ noSpace: priceWithoutPromoByFrequency }">
        <div class="inline center">
          <span class="barred small right-margin"
                v-if="priceWithoutPromoByFrequency">{{ priceWithoutPromoByFrequency | formatPrice }}</span> <span
          class="bold">{{ price.annual | formatPrice }}</span>
          <span class="unit">€ {{ priceLabel }} /{{ $tc('Offer.Product.year') }}</span>
        </div>
      </div>
    </template>
    <h2 v-for="detailDynamicProduct in detailsDynamicProduct">
        {{detailDynamicProduct.dynamicTrad}}
        <span v-if="detailDynamicProduct.isVariable" :class="isProductCDI(detailDynamicProduct.product) ? 'question-mark' : 'warning'" @click="openModalHelp(detailDynamicProduct.product)"></span>
    </h2>

    <button class="button secondary" :class="{TA:isTestAchat}" @click="showDetail(true, range)" v-if="price">
      {{ $t('Offer.Product.details') }}
    </button>
    <div class="services">
      <p v-if="label('label1')">{{ label('label1') }}</p>
      <p v-if="label('label2')">{{ label('label2') }}</p>
      <p v-if="label('label3')">{{ label('label3') }}</p>
      <p v-if="label('label4')">{{ label('label4') }}</p>
      <p v-if="label('isElectricityGreen')">{{label('isElectricityGreen')}}</p>
    </div>
    <div class="options">
      <div v-for="product in products" :key="product.id">
        <OptionField
            v-if="types(product)"
            :value="isFixed(product)"
            @input="changeType(types(product))"
            :label="$tc(`simulation.product.options.fix.${product.energyType}`,
        difference(product, types(product)) + 1,
        {n: $options.filters.toCurrency(difference(product, types(product)))})">
        </OptionField>
      </div>
      <OptionField
          v-if="durationsByRange(products)"
          :label="$tc(`simulation.product.options.duration`)"
          :value="isLongest(products[0])"
          @input="changeDuration(durationsByRange(products))"
      ></OptionField>
      <div v-for="product in products" :key="`green-${product.id}`">
        <OptionField
            v-if="greenDifference(product) && !isTestAchat"
            :label="$t(`Offer.Product.services.green`)"
            v-model="wantGreen"
        ></OptionField>

      </div>

    </div>
    <button v-if="!noSubscribe" class="button main" @click="redirect()">{{ $t('Offer.Product.become') }}</button>
    <WarningPrice v-if="showVariable" class="help" :productCDI="productCDI" :duration="products[0].duration" @close="showVariable = false"></WarningPrice>
  </div>
</template>

<script>
import OptionField from "./OptionField";
import {mapGetters, mapState} from "vuex";
import Detail from './Detail';
import WarningPrice from '../components/WarningPrice';
import capitalize from "@/mixins/capitalize";
import leadService from "@/services/leadService";
import enums from "@/enums";
import productCDDorCDI from "@/mixins/productCDDorCDI";

export default {
  mixins: [capitalize, productCDDorCDI],
  data() {
    return {
      detail: false,
      showVariable: false,
      annualPriceByRange: [enums.productEnum.PREPAID]
    }
  },
  props: {
    range: {
      type: Object,
    },
    showDisclaimer: {
      type: Boolean
    }
  },
  computed: {
    ...mapState("common", ["uuid", "agentJwt", "agentRef"]),
    ...mapState("contact", ["isPro"]),
    ...mapState("simulation", ["onlineGreenProduct", "onlineGrayProduct"]),
    ...mapGetters("common", ["isTestAchat"]),
    ...mapGetters("podium", ["featured"]),
    priceLabel() {
      return this.isPro ? this.$t('Offer.Product.ht') : this.$t('Offer.Product.ttc');
    },
    wantGreen: {
      set(value) {
        this.$store.commit("simulation/setWantGreen", value);
      },
      get() {
        return this.$store.state.simulation.wantGreen;
      }
    },
    wantOnlineGreen: {
      set(value) {
        this.$store.commit("simulation/setWantOnlineGreen", value);
      },
      get() {
        return this.$store.state.simulation.wantOnlineGreen;
      }
    },
    productName() {
      let product = this.range.electricity || this.range.gas;
      return product.labels.name;
    },
    products() {
      return this.$store.getters["simulation/selectedProducts"](this.range);
    },
    sameOptions() {
      return this.$store.getters["simulation/sameOptions"](this.range.range);
    },
    amountType() {
      return this.isPro ? "amountHTVA" : "amountTVAC";
    },
    price() {
      let products = this.products;
      let price = null;

      if (products[0].total) {
        price = {};

        if (this.isPro) {
          price.annual = products.reduce((x, y) => {
            if (this.wantGreen && y.total.priceEuroEco !== undefined) return x + y.total.priceEuroEco
            else return x + y.total.priceEuro;
          }, 0);
          price.monthly = products.reduce((x, y) => {
            if (this.wantGreen && y.total.priceEuroMonthlyEco !== undefined) return x + y.total.priceEuroMonthlyEco
            else return x + y.total.priceEuroMonthly;
          }, 0);
        } else {
          price.annual = products.reduce((x, y) => {
            if (this.wantGreen && y.total.priceEuroVATEco !== undefined) return x + y.total.priceEuroVATEco
            else return x + y.total.priceEuroVAT;
          }, 0);
          price.monthly = products.reduce((x, y) => {
            if (this.wantGreen && y.total.priceEuroMonthlyVATEco !== undefined) return x + y.total.priceEuroMonthlyVATEco
            else return x + y.total.priceEuroMonthlyVAT;
          }, 0);
        }
      }
      return price;
    },
    paymentFrequency() {
      return this.products[0].paymentFrequencies[0];
    },
    priceByFrequency() {
      let frequency = {
        monthly: 1,
        quarterly: 3
      }

      let multiply = frequency[this.paymentFrequency] || 1

      return this.price.monthly * multiply
    },
    priceWithoutPromo() {
      let priceWithoutPromo = {};

      if (this.range.products[0].subtotal && this.range.products[0].subtotal.discount) {
        priceWithoutPromo.annual = this.price.annual - this.range.products[0].subtotal.discount.priceEuroVAT;
        priceWithoutPromo.monthly = this.price.monthly - (this.range.products[0].subtotal.discount.priceEuroVAT / 12);
      }

      return priceWithoutPromo;
    },
    priceWithoutPromoByFrequency() {
      if (this.priceWithoutPromo.monthly) {
        let frequency = {
          monthly: 1,
          quarterly: 3
        }

        let multiply = frequency[this.paymentFrequency] || 1;

        return this.priceWithoutPromo.monthly * multiply
      } else {
        return null;
      }
    },
    noSubscribe() {
      return this.$router.currentRoute.query.noSubscribe !== undefined || this.$store.state.common.noSubscribe;
    },
    isYearly() {
      return this.paymentFrequency === "yearly";
    },
    detailsDynamicProduct() {
      // If the same type of energy contract
      if(this.products.every(product => product.contractType === 'fix') || this.products.every(product => product.contractType === 'variable')){
        const dynamicTrad = this.$tc(`Offer.Product.card.${this.labelPriceCDDorCDI(this.products[0])}`, this.products[0].duration, { n: this.products[0].duration });

        return [{
          dynamicTrad: dynamicTrad,
          product: this.products[0],
          isVariable: this.products[0].contractType === 'variable'
        }];
      } else {
        // The different types of energy contract
        return this.products.map(product=> {
          const dynamicTrad = this.$tc(`Offer.Product.card.${this.labelPriceCDDorCDI(product)}`, product.duration, { n: product.duration });
          return {
            dynamicTrad: `${dynamicTrad} ${this.$t(`Offer.Product.card.${product.energyType}`)}`,
            product: product,
            isVariable: product.contractType === 'variable'
          };
        })
      }
    }
  },
  methods: {
    label(labelName) {
      let product = this.range.electricity || this.range.gas;
      let label = product.labels[labelName][this.$i18n.locale];
      if (product.energyType === 'electricity' && labelName === 'isElectricityGreen'){
        return product.labels['isElectricityGreen'] ? this.$t(`greenElec`) : null;
      }
      return label && label.length ? label : null;
    },
    async redirect() {
      let data = {
        uuid: this.uuid,
      };

      if (this.range.electricity) {
        this.range.electricity['wantGreen'] = this.range.electricity.labels['isElectricityGreen'] ? 1 : 0;
        data["megaProductElec"] = this.range.electricity;
      }

      if (this.range.gas) {
        this.range.gas['wantGreen'] = this.wantGreen ? 1 : 0;
        data["megaProductGas"] = this.range.gas;
      }

      data['wantGreenProduct'] = this.wantOnlineGreen;

      try {
        await leadService.save(data);
      } catch (error) {
        console.error(error.response);
      }

      if (this.agentJwt) {
        window.location.href = `${process.env.BECOME}/agent/?newSession&agent=${this.agentRef}&jwt=${this.agentJwt}&lead=${this.uuid}&elec_custom_id=${this.$route.query['agent_ref_elec']}&gas_custom_id=${this.$route.query['agent_ref_gas']}`;
      } else if (this.isTestAchat) {
        window.location.href = `${process.env.BECOME}/lead/${this.uuid}?newSession&agent=${this.agentRef}&lead=${this.uuid}`;
      } else {
        window.location.href = `${process.env.BECOME}/lead/${this.uuid}?newSession`;
      }
    },
    become() {
      return this.$store.getters["middleware/become"](this.range);
    },
    showDetail(show, range) {
      this.$emit('showDetail', {show: show, range: range})
    },
    isFixed(product) {
      return product.contractType === "fix";
    },
    isLongest(product) {
      return this.durations(product) && product.duration > this.durations(product).duration;
    },
    difference(currentProduct, availableProduct) {
      let difference = 0;

      if (currentProduct.total) {
        let priceAvailable = this.isResidential ? availableProduct.total.priceEuroMonthlyVAT : availableProduct.total.priceEuroMonthly;
        let price = this.isResidential ? currentProduct.total.priceEuroMonthlyVAT : currentProduct.total.priceEuroMonthly;

        difference = Math.abs(priceAvailable - price);
      }

      return difference;
    },
    types(product) {
      let products = this.$store.getters["simulation/availableTypes"](product);
      return products.length ? products[0] : null;
    },
    durationsByRange() {
      let products = [];

      this.products.forEach((product) => {
        let durations = this.durations(product);

        if (durations) products.push(durations);
      });

      return products.length ? products : null;
    },
    differenceByRange(currentProducts, availableProducts) {
      let difference = 0;

      for (let i = 0; i < currentProducts.length; i++) {
        difference += this.difference(currentProducts[i], availableProducts[i]);
      }

      return difference;
    },
    durations(product) {
      let products = this.$store.getters["simulation/availableDurations"](product);

      return products.length ? products[0] : null;
    },
    greenDifference(product) {
      return product.total.priceEuroMonthlyVATEco !== undefined ? product.total.priceEuroMonthlyVATEco - product.total.priceEuroMonthlyVAT : 0;
    },
    async changeType(product) {
      let payload = {
        duration: product.duration,
        energy: product.energyType,
        type: product.contractType
      };

      this.$store.dispatch('simulation/changeProducts', payload);
      this.$emit("save");
    },
    changeDuration(products) {
      let payload = {
        duration: products[0].duration,
        type: products[0].contractType
      };

      products.forEach((product) => {
        payload['energy'] = product.energyType;
        this.$store.dispatch('simulation/changeProducts', payload);
      });
    }
  },
  filters: {
    toCurrency: function (value) {
      return value.toFixed(2).replace(".", ",");
    }
  },
  components: {
    OptionField,
    Detail,
    WarningPrice
  }
};
</script>

<style lang="scss" scoped>
.product {
  border-top: 15px solid $yellow;
  margin: 0;
  background: $white;
  border-radius: 15px;
  opacity: 0.5;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
  padding-bottom: 10px;

  .warning {
    cursor: pointer;
    display: inline-block;
    height: 13px;
    width: 13px;
    background: url("~@/assets/icons/icon-warning.svg") no-repeat bottom/contain;
  }

  .question-mark {
    $icon-size: 16px;
    cursor: pointer;
    display: inline-block;
    height: $icon-size;
    width: $icon-size;
    border-radius: $icon-size;
    background-color: $yellow;
    &:after{
      height: $icon-size;
      display: flex;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;
      font-size: 10px;
      content: "?";
    }
  }

  h1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0;
    font-size: 1.5rem;
    height: 80px;

    .icon {
      font-size: 2rem;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: center;
      max-height: 50px;
      margin-bottom: 4px; //for safari
    }
  }

  h2 {
    display: block;
    margin: 5px;
    font-size: 0.9rem;
  }

  .secondary {
    width: 100%;
    display: block;
    text-decoration: underline $yellow;
  }

  .price {
    background: $yellow;
    padding: 10px 0;
    font-size: 1.5rem;

    &.noSpace {
      padding: 2px;
      margin: 0;

      div {
        margin-bottom: 2px;
      }
    }

    div {
      margin-bottom: 5px;
    }

    .annual {
      font-size: 0.8rem;
      color: #000;
    }

    .unit {
      display: block;
      font-size: 0.5rem;
      width: 45px;
    }

    .bold {
      font-weight: bold;
    }

    .barred {
      text-decoration: line-through;
      display: block;
      text-align: left;
    }

    .small {
      font-size: 0.8rem;
      color: #000;
    }

    .smallest {
      font-size: 0.6rem;
      color: #000;
    }

    .right-margin {
      margin-right: 10px;
    }
  }

  .services {
    font-size: 0.8rem;
    background: #FEF1C4;
    margin-bottom: 10px;
    padding: 5px;

    p {
      text-align: left;
      margin: 10px;
    }
  }

  /deep/ .checkbox {
    .check-label {
      font-size: 0.8rem;
    }
  }

  .button.main {
    margin-bottom: 10px;
    background: $yellow !important;
  }

  .bestprice {
    top: 30px;
    right: -.6rem;
    padding: 5px 25px;
    position: absolute;
    display: block;
    line-break: auto;
    max-width: 50px;
    color: $yellow;
    text-align: left;
    font-size: .8rem;
    font-weight: bold;
    background-color: #000;
    border-radius: 25px 0 0 25px;
    box-shadow: 0 1px 3px rgba(35, 31, 32, .4);

    &::after {
      content: "";
      bottom: -.5rem;
      position: absolute;
      display: block;
      border-style: solid;
      border-color: #000 transparent transparent transparent;
      z-index: 3;
      right: 0;
      border-width: .6rem .6rem 0 0;
    }
  }

  .marketing-label {
    display: block;
    margin-top: 10px;
    font-weight: 500;
  }

  &.TA {
    border-top: 15px solid $orange;

    .price {
      background: $orange;
      color: $white;

      .annual {
        color: $white;
      }
    }

    .services {
      background: $lightGrey;
    }

    .button.main {
      background: $pink !important;
      color: $white !important;
      font-family: "Lato", Helvetica, Arial, sans-serif !important;
      border-radius: 5px;
    }

    .button.secondary {
      text-decoration: underline $pink;
      color: $pink !important;
    }

    .bestprice {
      color: $white
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/simulation/Product.vue